import styled, { css } from 'styled-components/macro';

const Table = styled.table<any>`
  color: ${({ theme }): string => theme.DeepBlue};
  min-width: 100%;
  border-spacing: 0;
  ${({ isBrowseTable, entity }): any =>
    isBrowseTable && entity !== 'label'
      ? css`
          display: flex;
          flex-direction: column;
          tbody {
            padding-right: 0.5em;
          }
        `
      : ''}
`;

/** @component */
export default Table;
